import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="More testimonials" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-108" data-mp="20fowudtw93h2">
      <h2 className="text-center font-display text-2xl font-black text-white sm:text-3xl" data-id="element-109" data-mp="25auta6kxa0je">
        ❤️ More Students Already Applying It
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-110" data-mp="1ckmb4eqdzg4t">
        {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i % 2 * 0.1} data-id="element-111" data-mp="1hk8lmgetyi9x" data-mpi={i} />)}
      </div>
    </section>;
}